export const STATUS_QUEUED = 1
export const STATUS_READY = 2
export const STATUS_COLLECTED = 3
